<div class="w-100 position-relative vh-100 d-flex flex-column">
    <div class="py-4 d-flex w-100 justify-content-center">
        <img class="w-75 px-2 py-4" src="public/logo_tim_enterprise.svg" alt="Logo Tim Enterprise" />
    </div>
    <ul class="list-unstyled px-4">
        <li class="mb-5">
            <button (click)="searchService.resetChat()" class="btn btn-primary w-100" href="#">+ Nuova Chat</button>
        </li>
        <li class="p-2 text-truncate w-100 text-start">
            <a [routerLink]="['/conversation-history']" [routerLinkActive]="['active']">
                <i class="btn-icon far fa-comments" aria-hidden="true"></i>
                Storico Conversazioni
            </a>
        </li>
        <li class="p-2 text-truncate w-100 text-start">
            <a [routerLink]="['/documents-history']" [routerLinkActive]="['active']">
                <i class="btn-icon far fa-file" aria-hidden="true"></i>
                Storico Documenti
            </a>
        </li>
    </ul>
    <div class="w-100 mt-auto">
        <app-user-profile></app-user-profile>
    </div>
</div>
